// C:\ViYash\XPRSuvey\XPRSuvey-App\src\Components\Survey\Services\ResponderService.js
import api from "../../axios";

export const SurveyDetailsByResponder = (responderUID) => {
  return api.get("/api/XPRS_Survey/XPRSSurveyResponder/SurveyDetailsByResponder", {
    params: { responderUID },
  });
};

export const GetSectionContent = (responderUID, section) => {
  return api.get("/api/XPRS_Survey/XPRSSurveyResponder/SectionContent", {
    params: { responderUID, section },
  });
};

export const StartSection = (responderUID, section) => {
  return api.post("/api/XPRS_Survey/XPRSSurveyResponder/StartSection", {
    responderUID,
    section,
  });
};

export const GetQuestionByID = (responderUID, section, id) => {
  return api.get("/api/XPRS_Survey/XPRSSurveyResponder/Question", {
    params: { responderUID, section, id },
  });
};

export const SaveAnswer = (responderUID, section, tempID, userAnswer) => {
  return api.post("/api/XPRS_Survey/XPRSSurveyResponder/SaveAnswer", {
    responderUID,
    section,
    tempID,
    userAnswer,
  });
};

export const SubmitSection = (responderUID, section, isAutoSubmit = false) => {
  return api.post("/api/XPRS_Survey/XPRSSurveyResponder/SubmitSection", {
    responderUID,
    section,
    isAutoSubmit,
  });
};

export const GetChannelsForExcel = () => {
  return api.get("/api/XPRS_Survey/XPRSSurveyResponder/Channel");
};
